import React, { useState, useEffect } from 'react';
import { API_URL } from '../config/API_URLS.tsx';
import { authenticatedFetch } from "../auth/RequestSigner.tsx";
import SuccessModal from './SuccessModal.tsx';
import ErrorModal from './ErrorModal.tsx';
import { PiQrCode } from "react-icons/pi";
import { useLocation } from 'react-router-dom';

function QRGenerated() {
    const [data, setData] = useState(null);
    const [isActive, setIsActive] = useState(false);
    const [successModalOpen, setSuccessModalOpen] = useState(false);
    const [errorModalOpen, setErrorModalOpen] = useState(false);
    const [modalMessage, setModalMessage] = useState("");
    const [showButton, setShowButton] = useState(false);

    // Get URL parameters
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const autoGenerate = searchParams.get('autoGenerate') === 'true';
    const show  = searchParams.get('show') === 'true';

    useEffect(() => {
        if (show) {
            setShowButton(true);
        } else {
            setShowButton(false);
        }
    }, [show]);

    const handleToggleClass = () => {
        setIsActive(!isActive);
    };

    const handleSubmit = async (event) => {

        // If event exists, prevent default behavior
        if (event) {
            event.preventDefault();
        }

        const document = localStorage.getItem('userDocument');
        try {
            const response = await authenticatedFetch(`${API_URL}/v1/qr?document=${document}`, {
                method: 'post',
                body: JSON.stringify({ user_document: 0, "registry_date": "string" }),
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            if (!response.ok) {
                throw new Error('Error en la solicitud');
            }

            const data = await response.json();
            setShowButton(false);
            setModalMessage('Código QR generado con éxito');
            setSuccessModalOpen(true);
            setData(data);

            handleToggleClass();
        } catch (error) {
            console.error('Error:', error);
            setModalMessage('Error al generar el código QR');
            setErrorModalOpen(true);
        }
    };

    // Automatically generate QR code if autoGenerate is true
    useEffect(() => {
        if (autoGenerate) {
            handleSubmit();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [autoGenerate]);

    return (
        <div className="flex flex-col items-center justify-center w-full px-4 py-8 lg:mb-16" data-testid="qr-generated-container">
            {isActive && (
                <div className="w-full max-w-md flex justify-center" data-testid="qr-generated-image-container">
                    <img 
                        className="w-full max-w-[350px] lg:max-w-[500px] shadow-lg rounded-xl"
                        src={`data:image/png;base64,${data}`} 
                        alt="Código QR" 
                        data-testid="qr-generated-image"
                    />
                </div>
            ) }
            {showButton && (
                <div className="w-full max-w-md" data-testid="qr-generated-button-container">
                    <button
                        onClick={handleSubmit}
                        className="w-full px-6 py-4 text-white text-lg font-semibold rounded-lg shadow-md flex items-center justify-between relative overflow-hidden group"
                        data-testid="qr-generated-generate-button"
                    >
                        <div className="absolute inset-0 bg-gradient-to-r from-purple-300 to-purple-700 transition-transform duration-500 ease-in-out"></div>
                        <div className="absolute inset-0 bg-gradient-to-l from-purple-300 to-purple-700 opacity-0 group-hover:opacity-100 transition-opacity duration-500 ease-in-out"></div>
                        <span className="z-10 flex items-center" data-testid="qr-generated-button-text">
                            <PiQrCode className="text-2xl mr-3" />
                            Generar código QR
                        </span>
                    </button>
                </div>
            )}

            <SuccessModal 
                isOpen={successModalOpen} 
                onClose={() => setSuccessModalOpen(false)} 
                message={modalMessage} 
                data-testid="qr-generated-success-modal"
            />

            <ErrorModal 
                isOpen={errorModalOpen} 
                onClose={() => setErrorModalOpen(false)} 
                message={modalMessage} 
                data-testid="qr-generated-error-modal"
            />
        </div>
    );
}

export { QRGenerated };
